import { render } from "./TaskDetailPage.vue?vue&type=template&id=f64a5208&scoped=true"
import script from "./TaskDetailPage.vue?vue&type=script&lang=js"
export * from "./TaskDetailPage.vue?vue&type=script&lang=js"

import "./TaskDetailPage.vue?vue&type=style&index=0&id=f64a5208&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f64a5208"]])

export default __exports__